import { Button, Modal, Typography } from "@mui/material";
import React from "react";
import { IoMdClose } from "react-icons/io";
import { StyledHorizontalDivider } from "../../apps/Profile/styles";
import {
  StyledMainContainer,
  StyledModalContainer,
} from "../../pages/Layout/styles";
import {
  StyledModalChildren,
  StyledModalCloseButton,
  StyledModalContentWrapper,
  StyledModalFooter,
  StyledModalHeader,
  StyledModalHeaderText,
} from "./styles";

const GModal = ({
  isOpen,
  onClose,
  children,
  title,
  closeOnOutsideClick = true,
  closeOnEscape = true,
  primaryButton = null,
  secondaryButton = null,
  width = undefined,
}) => {
  const closeModal = (_, reason) => {
    if (closeOnOutsideClick && reason === "backdropClick") return onClose();
    if (closeOnEscape && reason === "escapeKeyDown") return onClose();
  };
  return (
    <Modal open={isOpen} onClose={closeModal}>
      <StyledModalContainer>
        <StyledMainContainer $width={width}>
          <StyledModalContentWrapper>
            <StyledModalHeader>
              <StyledModalHeaderText>
                <Typography variant="h6" color="primary">
                  {title}
                </Typography>
                <StyledModalCloseButton onClick={onClose}>
                  <IoMdClose size="24px" />
                </StyledModalCloseButton>
              </StyledModalHeaderText>
            </StyledModalHeader>
            {children && <StyledModalChildren>{children}</StyledModalChildren>}
            <StyledHorizontalDivider />
            {primaryButton || secondaryButton ? (
              <StyledModalFooter>
                {secondaryButton && (
                  <Button
                    variant={secondaryButton.variant ?? "outlined"}
                    color={secondaryButton.color ?? "secondary"}
                    onClick={secondaryButton.onClick ?? onClose}
                    disabled={secondaryButton.disabled}
                    size={secondaryButton.size ?? "medium"}
                  >
                    {secondaryButton.text ?? "Cancel"}
                  </Button>
                )}
                {primaryButton && (
                  <Button
                    type={secondaryButton.type}
                    variant={primaryButton.variant ?? "contained"}
                    color={primaryButton.type ?? "primary"}
                    onClick={primaryButton.onClick}
                    disabled={primaryButton.disabled}
                    size={primaryButton.size ?? "medium"}
                    endIcon={primaryButton.endIcon}
                    startIcon={primaryButton.startIcon}
                  >
                    {primaryButton.loading
                      ? "Loading..."
                      : primaryButton.text ?? "Submit"}
                  </Button>
                )}
              </StyledModalFooter>
            ) : null}
          </StyledModalContentWrapper>
        </StyledMainContainer>
      </StyledModalContainer>
    </Modal>
  );
};

export default GModal;
